import { CommonBaseData } from './common-base-data';
export class CommonFileData extends CommonBaseData{
  public fileName: string;
  public delete: boolean;
  // ST-361 start
  // ダウンロード用ファイル名
  public downLoadFileName: string;
  // ST-361 end
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/common-file-data.ts